import "./WindMitigationInspection.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import PlatformOverview from "./sections/PlatformOverview";
import WhyWartmannUmzuege from "./sections/WhyWartmannUmzuege";
import ReadyToGrowYourRestaurant from "./sections/ReadyToGrowYourRestaurant";
import Footer from "@/reusable_sections/Footer";
export default function WindMitigationInspectionPage() {
  return <div>
      <Header />
      <Hero />
      <PlatformOverview />
      <WhyWartmannUmzuege />
      <ReadyToGrowYourRestaurant />
      <Footer />
    </div>;
}